import { ColDef, GridApi, GridReadyEvent } from '@ag-grid-community/core';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  AnalyticsService,
  DialogConfig,
  DialogService,
  FrkBreakpoint,
  ModalService,
  ResponsiveService,
  SimpleModalConfig,
} from '@frk/eds-components';
import { FormBuilder } from '@angular/forms';
import { fundNameGenerator, nameGenerator } from './literature-utils';

import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DocumentDetailComponent } from './literature-shared-component/document-detail/document-detail.component';
import { DocumentDownloadComponent } from './literature-shared-component/document-download/document-download.component';
import { DownloadContentWrapper } from './services/download';
import { DownloadLink } from './literature-fund-document/literature-fund-document.component';
import { DownloadService } from './services/download.service';
import { FundNameCellRendererComponent } from './literature-shared-component/fund-name-cell-renderer/fund-name-cell-renderer.component';
import { IconColumnComponent } from './literature-shared-component/icon-column/icon-column.component';
import { NoFilterDataOverLayComponent } from './literature-shared-component/no-filter-data-overlay/no-filter-data-overlay.component';
import { TranslateService } from '@shared/translate/translate.service';
import { NoRowOverlayRenderMyLiteratureComponent } from './my-literature/no-row-overlay-render/no-row-overlay-render.component';
import { ProfileService } from '@services/profile.service';
import {
  StickyFooterActionParam,
  ModalId,
  LiteratureDocumentListingState,
  LiteratureDocumentListingData,
  CartActionPerformed,
  EmailDetails,
  CartDetails,
  LiteratureDocument,
  CartCheckoutMode,
} from '@types';
import { CartHandlerService } from './services/cart-handler.service';
import { LiteratureGlobalConfigService } from './services/literature-global-config.service';
import { RegulatoryFundNameCellRendererComponent } from './literature-shared-component/regulatory-fund-name-cell-renderer/regulatory-fund-name-cell-renderer.component';
import { UserRole } from '@services/profile.interface';
import { SH } from '@utils/app.constants';
import { FundFilterService } from '@products/fund-listing/services/fund-filter.service';
import { SelectAllGroupHeaderComponent } from './literature-shared-component/select-all-group-header/select-all-group-header.component';
import { SelectCellRendererComponent } from './literature-shared-component/select-cell-renderer/select-cell-renderer.component';
import { StickyFooterService } from '@services/sticky-footer.service';

@Component({
  template: ``,
})
export abstract class LiteratureListingBaseComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy {
  constructor(
    protected responsiveService: ResponsiveService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected cartService: CartHandlerService,
    protected dialogService: DialogService,
    protected downloadService: DownloadService,
    protected translateService: TranslateService,
    protected formBuilder: FormBuilder,
    protected literatureConfig: LiteratureGlobalConfigService,
    protected modalService?: ModalService,
    protected profileService?: ProfileService,
    protected analyticsService?: AnalyticsService,
    protected fundFilterService?: FundFilterService,
    protected stickyFooterService?: StickyFooterService
  ) {
    super();
  }
  // to control the view in different screen
  isHandheld: boolean;
  isMobile: boolean;
  columnDefs: ColDef[];
  panelChecked = false;
  public loginSubscription: Subscription;
  public cartSubscription: Subscription;
  apiDateFormat = 'YYYY-MM-DD';
  nextUpdateDateFormat = 'MM/YY';
  frameworkComponents: any = {
    downloadRenderer: DocumentDownloadComponent,
    iconColumnComponent: IconColumnComponent,
    detailRenderer: DocumentDetailComponent,
    fundNameCellRendererComponent: FundNameCellRendererComponent,
    RegulatoryFundNameCellRenderer: RegulatoryFundNameCellRendererComponent,
    noRowsOverlayComponent: NoFilterDataOverLayComponent,
    noRowsOverlayComponentMyLiterature: NoRowOverlayRenderMyLiteratureComponent,
    selectAllGroupHeaderComponent: SelectAllGroupHeaderComponent,
    selectCellRendererComponent: SelectCellRendererComponent,
  };
  noRowsOverlayComponent = 'noRowsOverlayComponent';
  noRowsOverLayCompMyLiterature = 'noRowsOverlayComponentMyLiterature';
  config: DialogConfig = {
    hideFooter: true,
    closeBtnLabel: 'close',
  };
  gridApi: GridApi;

  gridPageSize?: number;
  rowCount = 0;
  rowCountValue = '';
  selectedNodes = [];
  multiSelectDialogData = [];
  download$: Observable<DownloadContentWrapper>;
  downloadLink: DownloadLink;
  dialogSubcription: Subscription;
  private responsiveSubscription: Subscription;
  dialogData = [];
  isCartConfigured = false;
  isDeleteConfigured = false;
  loaded: boolean;
  emailStickyButton: StickyFooterActionParam;
  downloadStickyButton: StickyFooterActionParam;
  addToCartStickyButton: StickyFooterActionParam;
  isInternational: boolean;
  checkedUrl: string;
  checkedUrlText: string;
  checkedUrlDesc: string;

  currentFilteredSelectedNodes;

  /**
   * close label for simple-modal
   */
  modalCloseBtnLabel = '';
  /**
   * pre - title for simple-modal
   */
  preTitle = '';
  /**
   * title for simple-modal
   */
  modalTitle = '';
  isRecipientAvailable = false;
  caveat = '';
  ModalIdValue = '';
  private unsubscribeBase$: Subject<void> = new Subject<void>();

  multiGridSelectedRows = [];

  selectAllNodes;
  confirmSelectionNodes;
  listingHref;
  maxSelectionLimit = 100;
  remainingNonSelectedRows;
  currentPageNonSelectedRows;
  ngOnInit(): void {
    this.setBreadcrumbItems();
    this.isInternational = this.literatureConfig.isInternational;
    this.cartSubscription = this.cartService
      .getCartItems()
      .subscribe((item: LiteratureDocumentListingState) => {
        if (CartActionPerformed.ADDED_FROM_GRID === item.cartAction) {
          this.dialogData = [];
          this.dialogData = item.cartItems;
          this.modalTitle = '';
          this.preTitle = '';
          this.ModalIdValue = 'cartModal';
          this.openModal(ModalId.Sticky_Modal);
          this.changeDetectorRef.detectChanges();
        }

        if (CartActionPerformed.ADDED_FROM_STICKY === item.cartAction) {
          this.dialogData = item.cartItems;
          this.changeDetectorRef.detectChanges();
        }
      });
    this.responsiveSubscription = this.responsiveService
      .getBreakpointObs$()
      .subscribe((bp: FrkBreakpoint) => {
        this.isHandheld = [FrkBreakpoint.Mobile, FrkBreakpoint.Tablet].includes(
          bp
        );
        this.isMobile = [FrkBreakpoint.Mobile].includes(bp);
        this.changeDetectorRef.detectChanges();
      });
  }

  abstract getDownloadUrl(url: string): string;

  abstract postEmailDocs(
    recipients: string[],
    litCodes: string[],
    showStatus?: (statusMessage: string) => void
  ): void;

  getCartConfiguration(): boolean {
    return this.isCartConfigured;
  }
  closeDialog(dialogId: string): void {
    this.modalService?.close(dialogId);
  }
  updateStorage(docId: string) {
    this.cartService.removeFromCart([docId]);
  }

  emptyCart(event: string) {
    if (event === 'cartModal') {
      this.cartService.emptyCartStorage();
    }
  }

  onSelectionChanged(
    event,
    href?: string,
    isMultiGrid?: boolean,
    isFilterNotRequired = false // For controlling execution of filter service methods.
  ) {
    this.rowCount = 0;
    // in case of card-view handle stickyfooter operations
    if (event?.literatureData) {
      const index = this.selectedNodes.findIndex(
        (node) => node.data.literatureData.rowId === event?.literatureData.rowId
      );
      // check for notlogged items addition mobile view
      this.checkLogInPpssAndLitItems(event);

      if (index > -1) {
        // Responsible for removing node from 'remove' action in 'email/download' window.
        this.selectedNodes.splice(index, 1);
        event.literatureData.isSelected = false;

        // We don't want to execute this, if source is product detail document section.
        // Since, we don't have pagination and all of the listing data.
        // This follow all below methods calls for 'setCheckboxState()'.
        if (!isFilterNotRequired) {
          this.fundFilterService.setCheckboxState(
            event?.literatureData.rowId,
            false
          );
        }
      } else {
        this.selectedNodes.push({ data: event });

        if (!isFilterNotRequired) {
          this.fundFilterService.setCheckboxState(
            event?.literatureData.rowId,
            true
          );
        }
      }
      this.rowCount = this.selectedNodes.length;
      if (this.selectedNodes.length === 0) {
        this.closeModal(ModalId.Sticky_Modal);
      }
    } else {
      // in case of desktop view
      let rowToUpdate;
      if (isMultiGrid) {
        this.combineSelectedRows(event);
        this.rowCount = this.multiGridSelectedRows.length;
        rowToUpdate = this.multiGridSelectedRows;
      } else {
        this.rowCount = event.api.getSelectedNodes().length;
        rowToUpdate = event.api.getSelectedNodes();
      }

      rowToUpdate.forEach((node) => {
        node.data.literatureData.isSelected = true;

        if (!isFilterNotRequired) {
          this.fundFilterService.setCheckboxState(
            node.data.literatureData.rowId,
            true
          );
        }

        if (
          this.selectedNodes.findIndex(
            (selectedNode) =>
              selectedNode.data.literatureData.rowId ===
              node.data.literatureData.rowId
          ) === -1
        ) {
          this.selectedNodes.push(event.node);
        }
      });

      // to deselect on manual click of checkbox in desktop view
      if (
        !isMultiGrid && // Restrict deselect operation when multi grid, as the same happens in its method 'combineSelectedRows()'.
        !event.node.isSelected() &&
        event.data.literatureData.isSelected !== false
        // Above 'isSelected' assertion will block the duplicate execution of "remove row", when done from 'download/email' modal window.
        // Also, intentionally done to assert against 'false', keeping 'undefined' and 'true' condition in scope.
      ) {
        event.data.literatureData.isSelected = false;

        if (!isFilterNotRequired) {
          this.fundFilterService.setCheckboxState(
            event.data.literatureData.rowId,
            false
          );
        }

        this.selectedNodes.splice(
          this.selectedNodes.findIndex(
            (node) =>
              node.data.literatureData.rowId ===
              event.node.data.literatureData.rowId
          ),
          1
        );
      }

      this.checkboxClickAnalytics(rowToUpdate, event.node);

      if (this.rowCount) {
        this.selectedNodes = isMultiGrid
          ? this.multiGridSelectedRows
          : this.selectedNodes;
      }
      // check for notlogged items addition desktop view for ppss
      this.checkLogInPpssAndLitItems(event?.node);
    }

    // Extract row count value for product detail doc section from rowCount.
    // While, for literature listing, fetch it from original product listing from 'getTotalCheckedChecboxes()'.
    // This is because, literature listing would have pagination and all records.
    this.rowCountValue = `${
      isFilterNotRequired
        ? this.rowCount
        : this.fundFilterService.getTotalCheckedChecboxes()
    } ${this.translateService.instant('literature.lit-sticky-item-selected')}`;

    if (this.rowCount) {
      this.multiSelectDialogData = [];
      this.selectedNodes.forEach((item) => {
        if (
          item.data.literatureData.downloadUrl &&
          !this.isLoginRequired(item.data.literatureData)
        ) {
          this.multiSelectDialogData.push({
            name: this.isInternational
              ? nameGenerator(item.data, this.translateService)
              : fundNameGenerator(item.data, this.translateService),
            rowId: item.data.literatureData.rowId,
          });
        }
      });
    }
    this.prepareStickFooter(href);
    // add bottom to top padding
    if (this.rowCount > 0) {
      this.stickyFooterService.updateStickyFooter(true);
    } else {
      this.stickyFooterService.updateStickyFooter(false);
    }
  }

  // Created Seperate selection change method for handling custom multi select checkbox
  onListingSelectionChanged(
    event,
    href?: string,
    isFromSelectAll?: boolean, //  To know if select all button clicked
    isSelected?: boolean
  ): void {
    this.listingHref = href;
    // Case 1: if user already selected maxSelectionLimit
    if (this.selectedNodes.length === this.maxSelectionLimit && isSelected) {
      this.openMaxSelectionLimit();
      if (isFromSelectAll) {
        this.gridApi?.refreshHeader();
      }
    } else if (isSelected && isFromSelectAll) {
      // To get select all items (previous +remaining non selected items<=maxSelectionLimit).
      this.remainingNonSelectedRows = this.getRemainingNonSelectedNodes(event);
      this.selectAllNodes = [
        ...this.selectedNodes,
        ...this.remainingNonSelectedRows,
      ];

      // To get confirm selection items (previous +current page non selected items<=maxSelectionLimit).
      this.currentPageNonSelectedRows = this.getCurrentNonSelectedNodes(event);
      this.confirmSelectionNodes = [
        ...this.selectedNodes,
        ...this.currentPageNonSelectedRows,
      ];
      this.openSelectAllModal();
    } else if (!isSelected && isFromSelectAll) {
      this.removeAllSelection(href);
    } else {
      // This covers single row selection
      this.selectIndividualRows(event, href, isSelected);
    }
    if (this.rowCount > 0) {
      this.stickyFooterService.updateStickyFooter(true);
    } else {
      this.stickyFooterService.updateStickyFooter(false);
    }
  }

  selectIndividualRows(event, href?: string, isSelected?: boolean) {
    // in case of card-view handle stickyfooter operations
    if (event?.literatureData) {
      const index = this.selectedNodes.findIndex(
        (node) => node.data.literatureData.rowId === event?.literatureData.rowId
      );
      if (index > -1) {
        // Responsible for removing node from 'remove' action in 'email/download' window.
        this.selectedNodes.splice(index, 1);
        event.literatureData.isSelected = false;
        this.fundFilterService.setCheckboxState(
          event?.literatureData.rowId,
          false
        );
      } else {
        this.selectedNodes.push({ data: event });
        event.literatureData.isSelected = true;
      }
      this.fundFilterService.setCheckboxState(
        event?.literatureData.rowId,
        isSelected
      );
      this.rowCount = this.selectedNodes.length;
      this.updateMultiSelectDialogData(event, event, href);
    } else {
      // in case of desktop view
      const rowToUpdate = [];
      this.updateSelectedList(event.node, isSelected);
      rowToUpdate.push(event.node);
      this.gridApi.refreshCells({
        columns: ['MULTI_SELECT_CHECKBOX'],
        rowNodes: [event.node],
      });
      this.rowCount = this.selectedNodes?.length;
      this.updateMultiSelectDialogData(event.node, rowToUpdate, href);
    }
  }

  removeAllSelection(href: string): void {
    this.selectedNodes.forEach((rowNode) => {
      rowNode.data.literatureData.isSelected = false;
      rowNode.setSelected(false);
      this.fundFilterService.setCheckboxState(
        rowNode.data.literatureData.rowId,
        false
      );
    });
    this.gridApi.refreshCells({
      columns: ['MULTI_SELECT_CHECKBOX'],
      rowNodes: [...this.selectedNodes],
    });
    this.rowCount = 0;
    const rowToUpdate = [...this.selectedNodes];
    this.selectedNodes = [];
    this.updateMultiSelectDialogData(this.selectedNodes, rowToUpdate, href);
  }

  updateMultiSelectDialogData(node, rowToUpdate, href: string): void {
    this.checkboxClickAnalytics(rowToUpdate, node);
    // Extract row count value for product detail doc section from rowCount.
    // While, for literature listing, fetch it from original product listing from 'getTotalCheckedChecboxes()'.
    // This is because, literature listing would have pagination and all records.
    this.rowCountValue = `${this.fundFilterService.getTotalCheckedChecboxes()} ${this.translateService.instant(
      'literature.lit-sticky-item-selected'
    )}`;

    if (this.rowCount) {
      this.multiSelectDialogData = [];
      this.selectedNodes.forEach((item) => {
        if (
          item.data.literatureData.downloadUrl &&
          !this.isLoginRequired(item.data.literatureData)
        ) {
          this.multiSelectDialogData.push({
            name: this.isInternational
              ? nameGenerator(item.data, this.translateService)
              : fundNameGenerator(item.data, this.translateService),
            rowId: item.data.literatureData.rowId,
          });
        }
      });
    }
    this.prepareStickFooter(href);

    // check for notlogged items addition desktop view Lit page
    this.checkLogInPpssAndLitItems(node);
    if (this.rowCount === 0) {
      this.closeModal(ModalId.Sticky_Modal);
    }
  }

  private checkLogInPpssAndLitItems(event) {
    if (
      (!event?.data?.literatureData?.loginRequired &&
        event?.data?.literatureData?.isSelected) ||
      (!event?.literatureData?.loginRequired &&
        event?.literatureData?.isSelected)
    ) {
      this.stickyFooterService.updateStickyFooterDialogData(true);
    }
  }

  updateSelectedRowData(rowId: string): void {
    this.rowCountValue = `${this.fundFilterService.getTotalCheckedChecboxes()} ${this.translateService.instant(
      'literature.lit-sticky-item-selected'
    )}`;

    if (this.rowCount) {
      const indexToRemove = this.multiSelectDialogData.findIndex(
        (dData) => dData.rowId === rowId
      );
      if (indexToRemove !== -1) {
        this.multiSelectDialogData.splice(indexToRemove, 1);
      }
    }
  }
  /**
   * Create array of selected rows from multiple AG Grids
   * @param event - Event data object from AG Grid
   */
  combineSelectedRows(event) {
    event.api.getRenderedNodes().map((rowNodes) => {
      if (rowNodes.selected) {
        let isRowAvailable = false;
        if (this.multiGridSelectedRows.length) {
          isRowAvailable = this.multiGridSelectedRows.some((existingRow) => {
            return (
              existingRow.data.literatureData.rowId ===
              rowNodes.data.literatureData.rowId
            );
          });
        }
        if (!isRowAvailable) {
          this.multiGridSelectedRows.push(rowNodes);
        }
      }
      if (!rowNodes.selected) {
        if (this.multiGridSelectedRows.length) {
          const availableRecordIndex = this.multiGridSelectedRows.findIndex(
            (existingRow) => {
              return (
                existingRow.data.literatureData.rowId ===
                rowNodes.data.literatureData.rowId
              );
            }
          );
          if (availableRecordIndex !== -1) {
            this.multiGridSelectedRows.splice(availableRecordIndex, 1);
          }
        }
      }
    });
  }

  // To get Current Page Remaining selected items max maxSelectionLimit
  // i.e. this.selectedNodes?.length + nonSelectedNodes.length === maxSelectionLimit
  getCurrentNonSelectedNodes(event) {
    let pageStart = 0;
    const currentPage = event?.api?.paginationGetCurrentPage() || 0;

    if (currentPage > 0) {
      pageStart = currentPage * this.gridPageSize;
    }

    const currentPageItems = event?.api?.getDisplayedRowCount();
    const pageEnd =
      pageStart +
      (currentPageItems < this.gridPageSize
        ? currentPageItems
        : this.gridPageSize);
    const nonSelectedNodes = [];
    for (let i = pageStart; i < pageEnd; i++) {
      const rowNode = event?.api?.getDisplayedRowAtIndex(i);
      const isSelected =
        this.selectedNodes.findIndex((existingRow) => {
          return (
            existingRow.data.literatureData.rowId ===
            rowNode.data.literatureData.rowId
          );
        }) !== -1;
      if (!isSelected) {
        nonSelectedNodes.push(rowNode);
      }
      if (
        this.selectedNodes?.length + nonSelectedNodes.length ===
        this.maxSelectionLimit
      ) {
        break;
      }
    }
    return nonSelectedNodes;
  }

  // To get Remaining selected items max maxSelectionLimit from start
  // i.e. this.selectedNodes?.length + nonSelectedNodes.length === maxSelectionLimit
  getRemainingNonSelectedNodes(event) {
    const filteredRows = event?.context?.filteredRows;
    const nonSelectedNodes = [];
    for (let i = 0; i < filteredRows?.length; i++) {
      const rowNode = event?.api?.getDisplayedRowAtIndex(i);
      const isSelected =
        this.selectedNodes.findIndex((existingRow) => {
          return (
            existingRow.data.literatureData.rowId ===
            rowNode.data.literatureData.rowId
          );
        }) !== -1;
      if (!isSelected) {
        nonSelectedNodes.push(rowNode);
      }
      if (
        this.selectedNodes?.length + nonSelectedNodes.length ===
        this.maxSelectionLimit
      ) {
        break;
      }
    }
    return nonSelectedNodes;
  }

  // The function combines the current and previous selected Nodes for document listing ag grid custom multi select
  addListingSelectedRows(nonSelectedNodes): void {
    nonSelectedNodes.forEach((rowNode) => {
      rowNode.data.literatureData.isSelected = true;
      rowNode.setSelected(true);
      this.selectedNodes.push(rowNode);
      this.fundFilterService.setCheckboxState(
        rowNode.data.literatureData.rowId,
        true
      );
    });
    this.rowCount = this.selectedNodes.length;
    this.gridApi.refreshCells({
      columns: ['MULTI_SELECT_CHECKBOX'],
      rowNodes: [...this.selectedNodes],
    });
    this.updateMultiSelectDialogData(
      [...this.selectedNodes],
      [],
      this.listingHref
    );
    this.closeModal(ModalId.Sticky_Modal);
  }

  // This methods updates the selected nodes for document listing only
  private updateSelectedList(rowNodes, add: boolean): void {
    let isRowAvailable = false;
    let availableRecordIndex = -1;

    // To Check if row node is available in selected nodes
    if (this.selectedNodes.length) {
      availableRecordIndex = this.selectedNodes.findIndex((existingRow) => {
        return (
          existingRow.data.literatureData.rowId ===
          rowNodes.data.literatureData.rowId
        );
      });
    }
    isRowAvailable = availableRecordIndex !== -1;
    // To add into selected list and product data on the basis of availability
    if (add && !isRowAvailable) {
      rowNodes.data.literatureData.isSelected = true;
      rowNodes.setSelected(true);
      this.selectedNodes.push(rowNodes);
      this.fundFilterService.setCheckboxState(
        rowNodes.data.literatureData.rowId,
        true
      );
    }
    // To remove into selected list and product data on the basis of availability
    if (!add && isRowAvailable) {
      rowNodes.data.literatureData.isSelected = false;
      rowNodes.setSelected(false);
      this.selectedNodes.splice(availableRecordIndex, 1);
      this.fundFilterService.setCheckboxState(
        rowNodes.data.literatureData.rowId,
        false
      );
    }
  }

  private checkboxClickAnalytics(rowToUpdate: string[], rowToDelete: boolean) {
    const orderedArray = Object.assign(rowToUpdate).sort(
      (a, b) => Number(a.rowIndex) - Number(b.rowIndex)
    );
    const lastRowChecked = orderedArray[orderedArray.length - 1];
    // FIX-ME: This method doesn't serve the purpose to record last checked as it always record 'n-1', post 're-order' by "row index".
    // For now, to make null checks, keeping '?' in below each fetch statements.
    // As it would fail when 'rowToUpdate' is empty and 'rowToDelete' has "unchecked row".
    this.checkedUrl = lastRowChecked?.data.literatureData.downloadUrl;
    this.checkedUrlText = lastRowChecked?.data.literatureData.dctermsTitle;
    this.checkedUrlDesc =
      lastRowChecked?.data.literatureData.dctermsDescription;
    if (!rowToDelete) {
      this.analyticsService.trackEvent({
        event: 'checkbox_click',
        name: this.checkedUrlText,
        label: this.checkedUrlDesc,
        link_url: this.checkedUrl,
      });
    }
  }

  onGridSizeChanged(): void {
    this.loaded = true;
  }

  isLoginRequired(data: LiteratureDocument) {
    if (data.loginRequired) {
      const profileInfo = this.literatureConfig.getUserProfile();
      return (
        !profileInfo.isLoggedIn ||
        UserRole[profileInfo?.profileInfo?.role] === SH.toLocaleLowerCase()
      );
    }
    return false;
  }
  onGridReady(params: GridReadyEvent) {
    this.loaded = false;
    this.gridApi = params.api;
    this.gridApi.forEachNode((node) => {
      if (node.data.literatureData?.isSelected) {
        node.setSelected(true);
      }
    });
  }

  prepareStickFooter(href?: string) {
    this.emailStickyButton = {
      hasAction: this.multiSelectDialogData.length > 0,
      buttonLabel: this.translateService.instant(
        'literature.lit-sticky-email-button'
      ),
      iconType: 'mail',
      actionTarget: href,
    };
    this.downloadStickyButton = {
      hasAction: this.multiSelectDialogData.length > 0,
      buttonLabel: this.translateService.instant(
        'literature.lit-sticky-download-button'
      ),
      iconType: 'download',
      actionTarget: href,
    };
    this.addToCartStickyButton = {
      hasAction:
        this.multiSelectDialogData.length > 0 &&
        !this.isInternational &&
        this.isCartConfigured,
      buttonLabel: this.translateService.instant('literature.Add-to-cart'),
      iconType: 'cart',
      actionTarget: href,
    };
    // check for notlogged items removal
    if (this.multiSelectDialogData.length === 0 || this.rowCount === 0) {
      this.stickyFooterService.updateStickyFooterDialogData(false);
    }
  }

  downloadSelectedDocs(url: string) {
    const literatureCodes = [];
    const mandatoryMaterialLitCodes = [];
    this.selectedNodes.forEach((node) => {
      if (
        node.data.literatureData.downloadUrl &&
        !this.isLoginRequired(node.data.literatureData)
      ) {
        const mandatoryMaterial = node.data.literatureData?.mandatoryMaterial;
        literatureCodes.push(node.data.literatureData?.docId);
        if (mandatoryMaterial?.length > 0) {
          mandatoryMaterialLitCodes.push(...mandatoryMaterial);
        }
      }
    });

    // this.download$ =
    this.downloadService
      .download$(url, {
        literatureCodes: [...mandatoryMaterialLitCodes, ...literatureCodes],
      })
      .pipe(takeUntil(this.unsubscribeBase$))
      .subscribe((data) => {
        if (data?.state !== 'DONE') {
          this.ModalIdValue = 'downloadProgressModal';
        } else {
          this.modalTitle = this.translateService.instant(
            'literature.lit-sticky-success-modal-title'
          );
          this.closeModal(ModalId.Sticky_Modal);
          this.openModal(ModalId.Sticky_Modal);
          this.ModalIdValue = ModalId.Success_Modal;
          this.changeDetectorRef.detectChanges();
        }
      });
    this.placeOrder(CartCheckoutMode.DOWNLOAD);
  }

  /**
   * Handle de-selection of literature document listing rows.
   * @param rowId unchecked row id for the doc row
   * @param isFilterNotRequired if the user is on product detail document section,
   * basically, will be used for controlling execution of filter service method(s)
   */
  deselectedDownloadDocs(rowId: string, isFilterNotRequired = false) {
    let isResponsiveStickyAction = false;
    const index = this.selectedNodes.findIndex((node) => {
      const nodeMatched = node.data.literatureData.rowId === rowId;
      if (nodeMatched) {
        if (node.context) {
          node.setSelected(false);
          node.data.literatureData.isSelected = false;
          this.gridApi.refreshCells({
            rowNodes: [node],
            columns: ['MULTI_SELECT_CHECKBOX'],
          });
          if (!isFilterNotRequired) {
            this.fundFilterService.setCheckboxState(
              node.data.literatureData.rowId,
              false
            );
          }
        } else {
          isResponsiveStickyAction = true;
          this.onSelectionChanged(node.data, null, false, isFilterNotRequired);
        }
      }
      return nodeMatched;
    });
    if (!isResponsiveStickyAction) {
      this.selectedNodes.splice(index, 1); // Responsible for removing node from 'remove' action in 'email/download' window.
      this.updateSelectedRowData(rowId);
    }
    if (this.selectedNodes.length === 0) {
      this.closeModal(ModalId.Sticky_Modal);
    }
    this.panelChecked = false;
    this.changeDetectorRef.detectChanges();
  }

  emailContinue(event: { recipients: EmailDetails[] }) {
    const litCodes = [];
    const mandatoryMaterialLitCodes = [];
    const recipients = event?.recipients?.map((item) => item.recipientEmailId);
    const statusMessage = (message) => {
      this.dialogService.close('recipientFundDocuments');
      this.config.title = message;
      this.dialogService.open('emailD3');
    };

    this.selectedNodes.forEach((item) => {
      if (
        item.data.literatureData.downloadUrl &&
        !this.isLoginRequired(item.data.literatureData)
      ) {
        const mandatoryMaterial = item.data.literatureData?.mandatoryMaterial;
        litCodes.push(item.data.literatureData.docId);
        if (mandatoryMaterial?.length > 0) {
          mandatoryMaterialLitCodes.push(...mandatoryMaterial);
        }
      }
    });

    this.postEmailDocs(
      recipients,
      [...litCodes, ...mandatoryMaterialLitCodes],
      statusMessage
    );
    this.emailSuccess();
    this.placeOrder(CartCheckoutMode.EMAIL);
  }

  operationToPerform(operationType: string): void {
    const noOfSelection = this.selectedNodes?.length;
    if (noOfSelection > this.maxSelectionLimit) {
      this.ModalIdValue = ModalId.Max_Cart_Limit;
      this.openModal(ModalId.Sticky_Modal);
    } else {
      if (operationType === 'email') {
        this.openEmailModal();
      } else if (operationType === 'download') {
        this.openDownloadModal();
      } else {
        this.addToCartFromStickyFooter();
      }
    }
  }

  addToCartFromStickyFooter() {
    const cartItems: LiteratureDocumentListingData[] = [];
    this.selectedNodes.forEach((item) => {
      if (!this.isLoginRequired(item.data.literatureData)) {
        cartItems.push(item.data);
      }
    });
    this.openCartModal();
    this.cartService.addToCart(
      cartItems,
      CartActionPerformed.ADDED_FROM_STICKY
    );

    if (cartItems.length === 1) {
      this.analyticsService.trackEvent({
        event: 'cart_add',
        detailed_event: 'Cart Add',
        action: 'add to cart',
        file_name: cartItems[0]?.literatureData?.dctermsTitle,
        file_lit_code: cartItems[0]?.literatureData?.docId,
        event_data: {
          cart_type: 'add to cart',
          file_lit_code: cartItems[0]?.literatureData?.docId,
          file_name: cartItems[0]?.literatureData?.dctermsTitle,
        },
      });
    }
    if (cartItems.length > 1) {
      this.analyticsService.trackEvent({
        event: 'batch_files',
        detailed_event: 'Batch Download or Email',
        action: 'add to cart',
        number_files: cartItems.length,
        event_data: {
          cart_action: 'add to cart',
          number_files: cartItems.length,
        },
      });
    }
  }

  openDownloadModal(): void {
    this.modalTitle = this.translateService.instant(
      'literature.lit-sticky-download-modal-title'
    );
    this.preTitle = '';
    this.ModalIdValue = ModalId.Download_Modal;
    this.openModal(ModalId.Sticky_Modal);
  }

  openSelectAllModal(): void {
    this.modalTitle = '';
    this.preTitle = '';
    this.ModalIdValue = ModalId.Selection_All_Modal;
    this.openModal(ModalId.Sticky_Modal);
  }
  openMaxSelectionLimit(): void {
    this.modalTitle = '';
    this.preTitle = '';
    this.ModalIdValue = ModalId.Max_Selection_Limit;
    this.openModal(ModalId.Sticky_Modal, '');
  }
  openEmailModal(): void {
    if (this.selectedNodes.length === 1) {
      this.modalTitle = this.translateService.instant(
        'literature.lit-sticky-mail-progress-modal-title'
      );
      this.preTitle = this.translateService.instant(
        'literature.lit-sticky-email-progress-modal-pretitle'
      );
      this.ModalIdValue = 'recipientsDetailModal';
      this.openModal(ModalId.Sticky_Modal);
    } else {
      this.modalTitle = this.translateService.instant(
        'literature.lit-sticky-email-modal-title'
      );
      this.preTitle = this.translateService.instant(
        'literature.lit-sticky-email-initial-modal-pretitle'
      );
      this.ModalIdValue = 'emailModal';
      this.openModal(ModalId.Sticky_Modal);
    }
  }

  openModal(modalId: string, title?: string) {
    const config: SimpleModalConfig = {
      modalId,
      closeBtnLabel: this.modalCloseBtnLabel,
      title: this.modalTitle ? this.modalTitle : title,
      type: 'simple',
      body: '',
      themeTitle: 'dark',
      preTitle: this.preTitle,
      eventName: 'lightbox_display',
      eventAction: 'click',
      eventLabel: 'Literature: Add to Cart',
    };
    this.modalService.open(modalId, config);
  }

  private openCartModal(): void {
    this.dialogData = [];
    this.modalTitle = '';
    this.preTitle = '';
    this.ModalIdValue = 'cartModal';
    this.openModal(ModalId.Sticky_Modal);
    this.changeDetectorRef.detectChanges();
  }

  closeModal(modalId: string) {
    if (this.modalService) {
      this.modalService?.close(modalId);
    }
  }

  startEmail(): void {
    this.modalTitle = this.translateService.instant(
      'literature.lit-sticky-mail-progress-modal-title'
    );
    this.preTitle = this.translateService.instant(
      'literature.lit-sticky-email-progress-modal-pretitle'
    );
    this.closeModal(ModalId.Sticky_Modal);
    this.openModal(ModalId.Sticky_Modal);
    this.ModalIdValue = 'recipientsDetailModal';
    this.analyticsService.trackEvent({
      event: 'batch_files',
      detailed_event: 'Batch Download or Email',
      action: 'email',
      event_data: {
        cart_action: 'email',
        number_files: this.multiSelectDialogData.length,
      },
      number_files: this.multiSelectDialogData.length,
    });
  }

  emailBack(): void {
    this.ModalIdValue = ModalId.Email_Modal;
    this.modalTitle = this.translateService.instant(
      'literature.lit-sticky-email-modal-title'
    );
    this.preTitle = this.translateService.instant(
      'literature.lit-sticky-email-initial-modal-pretitle'
    );
    this.closeModal(ModalId.Sticky_Modal);
    this.openModal(ModalId.Sticky_Modal);
  }

  emailSuccess(): void {
    this.preTitle = '';
    this.modalTitle = this.translateService.instant(
      'literature.lit-sticky-success-modal-title'
    );
    this.closeModal(ModalId.Sticky_Modal);
    this.openModal(ModalId.Sticky_Modal, this.modalTitle);
    this.ModalIdValue = ModalId.Success_Email_Modal;
  }

  startDownload() {
    this.config.title = '';
    this.modalTitle = this.translateService.instant(
      'literature.lit-sticky-download-progress-modal-title'
    );
    this.ModalIdValue = 'downloadProgressModal';
    this.downloadSelectedDocs(this.cartService.getDownloadUrl());
    this.analyticsService.trackEvent({
      event: 'batch_files',
      detailed_event: 'Batch Download or Email',
      action: 'download',
      event_data: {
        cart_action: 'download',
        number_files: this.multiSelectDialogData.length,
      },
      number_files: this.multiSelectDialogData.length,
    });
  }
  getDeleteConfiguration(): boolean {
    return this.isDeleteConfigured;
  }
  /**
   * place order when document is downloaded / email is sent from sticky footer
   */
  placeOrder(checkoutMode) {
    const orderItems: CartDetails[] = this.selectedNodes.map((item) => {
      return {
        literatureCode: item.data.literatureData.docId,
        qty: 1,
      };
    });
    this.cartService.checkoutOrder(orderItems, checkoutMode);
  }

  isMaxLimitReached(): boolean {
    return this.selectedNodes.length === this.maxSelectionLimit;
  }

  ngOnDestroy() {
    this.loginSubscription?.unsubscribe();
    this.cartSubscription?.unsubscribe();
    this.responsiveSubscription?.unsubscribe();
    this.unsubscribeBase$.next();
    this.unsubscribeBase$.complete();
    this.multiGridSelectedRows = [];
  }
}
